import { useState } from 'react';

export const useAddToCartAnimation = () => {
  const [isAnimating, setIsAnimating] = useState(false);

  const triggerAnimation = () => {
    setIsAnimating(true);
    setTimeout(() => {
      setIsAnimating(false);
    }, 1500); // Animation duration
  };

  return {
    isAnimating,
    triggerAnimation,
  };
}; 